import React, { FC } from "react";
import { Redirect, RedirectProps, useRouteMatch } from "react-router";
import { KeepProps, Nesting } from "./types";
import { mergeParamsToLocation, useKeeperParams } from "./NavLink";

const PRedirect: FC<RedirectProps & KeepProps & Nesting> = ({
  persist,
  nest,
  to,
  ...props
}) => {
  const { path, params } = useRouteMatch();
  const keepers = useKeeperParams(persist);
  const root = nest ? path : undefined;
  const newTo = mergeParamsToLocation(to, { keepers, root, params });
  return <Redirect {...props} to={newTo} />;
};
export default PRedirect;
